// extracted by mini-css-extract-plugin
export default {"root":"_3VFaa","popover":"cDgR4","content":"RVVpZ","list":"_2XIem","list-item":"_1GWkf","listItem":"_1GWkf"};